import HeaderProp from "./FichaPropiedad/HeaderProp";
import Awards from "./FichaPropiedad/Awards";
import BookingBar from "./FichaPropiedad/BookingBar";
import Experiences from "./FichaPropiedad/Experiences";
import Faqs from "./FichaPropiedad/Faqs";
import Gallery from "./FichaPropiedad/Gallery";
import Hero from "./FichaPropiedad/Hero";
import HotelDescription from "./FichaPropiedad/HotelDescription";
import HotelNav from "./FichaPropiedad/HotelNav";
import Location from "./FichaPropiedad/Location";
import Offers from "./FichaPropiedad/Offers";
import Restaurants from "./FichaPropiedad/Restaurants";
import Reviews from "./FichaPropiedad/Reviews";
import Rooms from "./FichaPropiedad/Rooms";
import StayGreen from "./FichaPropiedad/StayGreen";
import WhyChooseUs from "./FichaPropiedad/WhyChooseUs";
import Contacta from "./FichaPropiedad/Contacta";
import Otros from "./FichaPropiedad/Otros";
import BrandsSection from "./Compartido/BrandsSection";
import Footer from "./Compartido/Footer";

const FichaPropiedad = (props) => {
    return (
        <>
            <HeaderProp
                config={props.websgrupo}
                lang={props.lang}
                meta_titulo={props.propiedad.nombre}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                idiomas={props.idiomas}
                propiedad={props.propiedad}
                destino={props.eldestino}
                destinos={props.destinos}
                experiencias={props.experiencias}
                comentarios={props.comentarios}
            ></HeaderProp>
            <main className="min-h-screen main hotel page-hotel">
                <Hero
                    propiedad={props.propiedad}
                    ruta={props.ruta}
                    config={props.websgrupo}
                />
                <BookingBar
                    lang={props.lang}
                    destinos={props.destinos}
                    capacidad_maxima={props.propiedad.capacidad_maxima}
                />
                <HotelNav
                    activeSection='hotel'
                />
                <div className="container">
                    <HotelDescription
                        propiedad={props.propiedad}
                        ruta={props.ruta}
                        lang={props.lang}
                    />
                    <Gallery
                        propiedad={props.propiedad}
                        ruta={props.ruta}
                    />
                    {/* <Offers
                        lang={props.lang}
                        config={props.websgrupo}
                        ruta={props.ruta}
                    />*/}
                    <WhyChooseUs />
                    <Location
                        propiedad={props.propiedad}
                    />
                    <Rooms
                        relacionados={props.relacionados}
                        ruta={props.ruta}
                        lang={props.lang}
                    />
                    {props.comercios && props.comercios.length > 0 ?
                        <Restaurants
                            comercios={props.comercios}
                            ruta={props.ruta}
                        />
                        :
                        ""
                    }
                    <Reviews
                        comentarios={props.comentarios}
                        lang={props.lang}
                    />
                    <Faqs
                        faqs={props.faqs}
                        lang={props.lang}
                    />
                    <Contacta
                        config={props.websgrupo}
                    />
                    {/*<Otros /> */}
                </div>
                <button type="button" aria-label="Subir al inicio" className="btn btn-primary o-btn-scrollup">
                    <svg aria-hidden="true">
                        <use xlinkHref="#icon-angle-up"></use>
                    </svg>
                </button>
            </main>
            <app-footer>
                <BrandsSection
                    lang={props.lang}
                    marcas={props.marcas}
                    ruta={props.ruta}
                />
                <Footer
                    lang={props.lang}
                    config={props.websgrupo}
                />
            </app-footer>
        </>
    );
}

export default FichaPropiedad;
